import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';
import HELPER from '@/app/utils/HELPER';
import BaseSettingHandler from './BaseSettingHandler';

/**
 * ShPaginatorLayout
 */
export class ShPaginatorLayout extends BaseSettingHandler {
  /**
   * read
   * @param options options
   * @returns returns
   */
  read(options: { $atom: JQuery; $activePanel: JQuery; atomModel: AtomModel; screenType: string }) {
    const { $atom, $activePanel } = options;
    const { targetSelector } = this.setting;
    const style = options.atomModel.style;
    if (!targetSelector) return;
    let layout = HELPER.getValueFromCSS(
      $atom.find(targetSelector),
      style,
      'border-style',
      options.screenType,
      'span.page',
    );
    if (layout == '') {
      layout = $atom.find('span.page').css('border-style');
    }
    if (layout == 'solid') {
      layout = 'button';
    } else {
      layout = 'simple';
    }
    $activePanel.find('#layout').val(layout).attr('value', layout).trigger('value-change');
  }

  /**
   * write
   * @param value  value
   * @param options options
   * @returns returns
   */
  write(
    value: any,
    options: {
      $atom: JQuery;
      $activePanel: JQuery;
      atomModel: AtomModel;
      screenType: string;
    },
  ): { refreshType: string; style?: string | undefined } {
    const { $atom, $activePanel, atomModel, screenType } = options;
    let style = atomModel.style;
    const layout = value as string;
    const btnSize = layout == 'simple' ? 'auto' : ($activePanel.find('#btn-size').val() as string);

    let deOptions = [
      {
        key: 'width',
        value: btnSize,
      },
      {
        key: 'height',
        value: btnSize,
      },
      {
        key: 'line-height',
        value: btnSize,
      },
      {
        key: 'border-radius',
        value: $activePanel.find('#btn-shape').val() == 'square' ? '0px' : parseInt(btnSize) / 2 + 'px',
      },
      {
        key: 'border-style',
        value: layout == 'simple' ? 'none' : 'solid',
      },
    ];

    style = HELPER.designOptions2Style(
      $atom.find('.gf_collection-paginator-wrapper'),
      screenType,
      style,
      deOptions,
      'span.page',
    );
    style = HELPER.designOptions2Style(
      $atom.find('.gf_collection-paginator-wrapper'),
      screenType,
      style,
      deOptions,
      'span.deco',
    );

    deOptions = [
      {
        key: 'width',
        value: 'auto',
      },
      {
        key: 'height',
        value: btnSize,
      },
      {
        key: 'line-height',
        value: btnSize,
      },
      {
        key: 'border-radius',
        value: $activePanel.find('#btn-shape').val() == 'square' ? '0px' : parseInt(btnSize) / 2 + 'px',
      },
      {
        key: 'padding-left',
        value: layout == 'simple' ? 'auto' : '10px',
      },
      {
        key: 'padding-right',
        value: layout == 'simple' ? 'auto' : '10px',
      },

      {
        key: 'border-style',
        value: layout == 'simple' ? 'none' : 'solid',
      },
    ];

    style = HELPER.designOptions2Style(
      $atom.find('.gf_collection-paginator-wrapper'),
      screenType,
      style,
      deOptions,
      'span.prev',
    );
    style = HELPER.designOptions2Style(
      $atom.find('.gf_collection-paginator-wrapper'),
      screenType,
      style,
      deOptions,
      'span.next',
    );

    return {
      refreshType: 'css',
      style,
    };
  }
}

/**
 * ShPaginatorBtnSpacing
 */
export class ShPaginatorBtnSpacing extends BaseSettingHandler {
  /**
   * read
   * @param options options
   */
  read(options: { $atom: JQuery; $activePanel: JQuery }) {
    const { $atom, $activePanel } = options;
    let btnSpacing = $atom.find('span.page').css('margin-left');
    if (btnSpacing == '0px') {
      btnSpacing = $atom.find('span.page').css('margin-right');
    }
    $activePanel.find('#btn-spacing').val(btnSpacing).attr('value', btnSpacing).trigger('value-change');
  }
  /**
   * write
   * @param value value
   * @param options options
   * @returns returns
   */
  write(
    value: any,
    options: {
      $atom: JQuery;
      atomModel: AtomModel;
      $activePanel: JQuery;
      screenType: string;
    },
  ): { refreshType: string; style?: string | undefined } {
    const { $atom, atomModel, $activePanel, screenType } = options;
    const align = $activePanel.find('#align_' + screenType).val();
    let style = atomModel.style;
    const deOptions = [
      {
        key: 'margin',
        value: '0px ' + (align == 'right' ? '0px' : value) + ' 5px ' + (align == 'left' ? '0px' : value),
      },
    ];

    style = HELPER.designOptions2Style(
      $atom.find('.gf_collection-paginator-wrapper'),
      screenType,
      style,
      deOptions,
      'span.page',
    );
    style = HELPER.designOptions2Style(
      $atom.find('.gf_collection-paginator-wrapper'),
      screenType,
      style,
      deOptions,
      'span.deco',
    );

    style = HELPER.designOptions2Style(
      $atom.find('.gf_collection-paginator-wrapper'),
      screenType,
      style,
      deOptions,
      'span.prev',
    );
    style = HELPER.designOptions2Style(
      $atom.find('.gf_collection-paginator-wrapper'),
      screenType,
      style,
      deOptions,
      'span.next',
    );

    return {
      refreshType: 'css',
      style,
    };
  }
}

/**
 *
 */
export class ShPaginatorText extends BaseSettingHandler {
  /**
   * read
   * @param options options
   */
  read(options: { $atom: JQuery; $activePanel: JQuery; atomModel: AtomModel; screenType: string }) {
    const { $atom, $activePanel, atomModel, screenType } = options;
    let textColor = HELPER.getValueFromCSS(
      $atom.find('.gf_collection-paginator-wrapper'),
      atomModel.style,
      this.setting.property,
      screenType,
      this.setting.targetSelector,
    );
    if (textColor == undefined || textColor == '') {
      textColor = $atom.find(this.setting.targetSelector as string).css(this.setting.property);
    }
    $activePanel.find(`[name="${this.setting.name}"]`).val(textColor).attr('value', textColor).trigger('value-change');
    return { value: textColor };
  }

  /**
   * write
   * @param value value
   * @param options options
   * @returns
   */
  write(
    value: any,
    options: { $atom: JQuery; atomModel: AtomModel; screenType: string },
  ): { refreshType: string; style?: string | undefined } {
    const { $atom, atomModel, screenType } = options;
    let style = atomModel.style;
    const deOptions = [
      {
        key: this.setting.property,
        value,
      },
    ];
    if (this.setting.targetSelectors && this.setting.targetSelectors.length) {
      this.setting.targetSelectors.forEach((selector) => {
        style = HELPER.designOptions2Style(
          $atom.find('.gf_collection-paginator-wrapper'),
          screenType,
          style,
          deOptions,
          selector,
        );
      });
    } else {
      style = HELPER.designOptions2Style(
        $atom.find('.gf_collection-paginator-wrapper'),
        screenType,
        style,
        deOptions,
        this.setting.targetSelector,
      );
    }
    return {
      refreshType: 'css',
      style,
    };
  }
}
